const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  GET_CLIENT_DATA_BEGINS: "GET_CLIENT_DATA_BEGINS",
  GET_CLIENT_DATA_SUCCESS: "GET_CLIENT_DATA_SUCCESS",
  GET_CLIENT_DATA_FAILURE: "GET_CLIENT_DATA_FAILURE",
  RESET_CLIENT_DATA: "RESET_CLIENT_DATA",
  GET_DEBT_PAYMENT_BEGIN: "GET_DEBT_PAYMENT_BEGIN",
  GET_DEBT_PAYMENT_SUCCESS: "GET_DEBT_PAYMENT_SUCCESS",
  GET_DEBT_PAYMENT_FAILURE: "GET_DEBT_PAYMENT_FAILURE",
  // MOVISTAR PLUS EMAIL
  GET_EMAIL_MOVISTAR_PLUS_BEGINS: "GET_EMAIL_MOVISTAR_PLUS_BEGINS",
  GET_EMAIL_MOVISTAR_PLUS_SUCCESS: "GET_EMAIL_MOVISTAR_PLUS_SUCCESS",
  GET_EMAIL_MOVISTAR_PLUS_FAILURE: "GET_EMAIL_MOVISTAR_PLUS_FAILURE",
  // MOVISTAR PLUS EMAILS
  GET_EMAILS_MOVISTAR_PLUS_BEGINS: "GET_EMAILS_MOVISTAR_PLUS_BEGINS",
  GET_EMAILS_MOVISTAR_PLUS_SUCCESS: "GET_EMAILS_MOVISTAR_PLUS_SUCCESS",
  GET_EMAILS_MOVISTAR_PLUS_FAILURE: "GET_EMAILS_MOVISTAR_PLUS_FAILURE",
  // CONTACT MEANS
  POST_MODIFY_CONTACT_MEANS_BEGIN: "POST_MODIFY_CONTACT_MEANS_BEGIN",
  POST_MODIFY_CONTACT_MEANS_SUCCESS: "POST_MODIFY_CONTACT_MEANS_SUCCESS",
  POST_MODIFY_CONTACT_MEANS_FAILURE: "POST_MODIFY_CONTACT_MEANS_FAILURE",
  RESET_MODIFY_CONTACT_MEANS: "RESET_MODIFY_CONTACT_MEANS",
  CLIENTE_DATA_UPDATE: "CLIENTE_DATA_UPDATE",
  RESET_CLIENTE_DATA_UPDATE: "RESET_CLIENTE_DATA_UPDATE",
  // CONTACT MEANS
  SET_URLS_CLIENT: "SET_URLS_CLIENT",
  //DEBT
  GET_DEBT_PAYMENT_BEGIN: 'GET_DEBT_PAYMENT_BEGIN',
  GET_DEBT_PAYMENT_SUCCESS: 'GET_DEBT_PAYMENT_SUCCESS',
  GET_DEBT_PAYMENT_FAILURE: 'GET_DEBT_PAYMENT_FAILURE',
  // NEW CONTACT MEANS
  SET_NEW_CONTACT: "SET_NEW_CONTACT",
  RESET_NEW_CONTACT: "RESET_NEW_CONTACT",
  // CHANGE PASSWORD
  CHANGE_PASSWORD_BEGINS: 'CHANGE_PASSWORD_BEGINS',
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE: 'CHANGE_PASSWORD_FAILURE',
  CHANGE_PASSWORD_RESET: 'CHANGE_PASSWORD_RESET',
};
export const initialState = {
  // CLIENT DATA
  urlLibrary: null,
  clientInfo: null,
  additionalInfo: null,
  clientError: false,
  clientFetching: false,

  debtPayment: null,
  debtPaymentFetching: false,
  debtPaymentError: false,

  // MOVISTAR PLUS EMAIL
  emailMovistarPlus: [],
  emailMovistarPlusFetching: false,
  emailMovistarPlusFetched: false,
  emailMovistarPlusError: false,
  // MOVISTAR PLUS EMAILS
  emailsMovistarPlus: null,
  emailsMovistarPlusError: false,
  emailsMovistarPlusFetching: false,
  emailsMovistarPlusFetched: false,

  modifyContactMeans: null,
  modifyContactMeansFetching: false,
  modifyContactMeansError: false,
  clientDataUpdated: false,
  // DEBTPAYMENT
  debtPayment: null,
  debtPaymentFetching: false,
  debtPaymentError: false,
  // NEW CONTACT MEANS
  newContact: null,
  // CHANGE PASSWORD
  changePasswordStatus: null,
  changePasswordFetching: false,
  changePasswordError: null,

};

export const actions = {
  getClientData: () => ({ type: types.GET_CLIENT_DATA_BEGINS }),
  successGetClientData: ({ clientInfo, additionalInfo }) => ({
    type: types.GET_CLIENT_DATA_SUCCESS,
    payload: { clientInfo, additionalInfo },
  }),
  failureGetClientData: (error) => ({
    type: types.GET_CLIENT_DATA_FAILURE,
    payload: error,
  }),
  resetClientData: () => ({ type: types.RESET_CLIENT_DATA }),

  getDebtPaymentData: () => ({ type: types.GET_DEBT_PAYMENT_BEGIN }),
  successGetDebtPayment: (data) => ({
    type: types.GET_DEBT_PAYMENT_SUCCESS,
    payload: data,
  }),
  failureGetDebtPayment: (error) => ({
    type: types.GET_DEBT_PAYMENT_FAILURE,
    payload: error,
  }),
  // Movistar Plus Email
  getEmailMPlus: (productId) => ({
    type: types.GET_EMAIL_MOVISTAR_PLUS_BEGINS,
    productId,
  }),
  successGetEmailMPlus: (email) => ({
    type: types.GET_EMAIL_MOVISTAR_PLUS_SUCCESS,
    payload: email,
  }),
  failureGetEmailMPlus: (error) => ({
    type: types.GET_EMAIL_MOVISTAR_PLUS_FAILURE,
    payload: error,
  }),

  getEmailsMPlus: (productIdList) => ({
    type: types.GET_EMAILS_MOVISTAR_PLUS_BEGINS,
    productIdList,
  }),
  successGetEmailsMPlus: (email) => ({
    type: types.GET_EMAILS_MOVISTAR_PLUS_SUCCESS,
    payload: email,
  }),
  failureGetEmailsMPlus: (error) => ({
    type: types.GET_EMAILS_MOVISTAR_PLUS_FAILURE,
    payload: error,
  }),
  // Contact Means

  postModifyContactMeans: (params) => ({
    type: types.POST_MODIFY_CONTACT_MEANS_BEGIN,
    payload: params,
  }),
  successPostModifyContactMeans: (data) => ({
    type: types.POST_MODIFY_CONTACT_MEANS_SUCCESS,
    payload: data,
  }),
  failurePostModifyContactMeans: (error) => ({
    type: types.POST_MODIFY_CONTACT_MEANS_FAILURE,
    payload: error,
  }),
  resetModifyContactMeans: () => ({ type: types.RESET_MODIFY_CONTACT_MEANS }),
  clientDataUpdate: () => ({ type: types.CLIENTE_DATA_UPDATE}),
  resetClientDataUpdate: () => ({ type: types.RESET_CLIENTE_DATA_UPDATE}),
  setUrlsClient: (data) => ({
    type: types.SET_URLS_CLIENT,
    payload: data,
  }),
  getDebtPaymentData: () => ({ type: types.GET_DEBT_PAYMENT_BEGIN }),
  successGetDebtPayment: data => ({ type: types.GET_DEBT_PAYMENT_SUCCESS, payload: data }),
  failureGetDebtPayment: error => ({ type: types.GET_DEBT_PAYMENT_FAILURE, payload: error }),
  // NEW CONTACT MEANS
  setNewContact: data => ({ type: types.SET_NEW_CONTACT, payload: data}),
  resetNewContact: () => ({ type: types.RESET_NEW_CONTACT}),
  // CHANGE PASSWORD
  changePassword: data => ({ type: types.CHANGE_PASSWORD_BEGINS, payload: data }),
  changePasswordSuccess: () => ({ type: types.CHANGE_PASSWORD_SUCCESS }),
  changePasswordFailure: data => ({ type: types.CHANGE_PASSWORD_FAILURE, payload: data }),
  changePasswordReset: () => ({ type: types.CHANGE_PASSWORD_RESET }),
};

function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { client } = payload;
      return {
        ...state,
        ...client,
      };
    }
    case types.GET_CLIENT_DATA_BEGINS:
      return {
        ...state,
        clientFetching: true,
        clientError: false,
      };
    case types.GET_CLIENT_DATA_SUCCESS:
      return {
        ...state,
        clientInfo: payload.clientInfo,
        additionalInfo: state.additionalInfo || payload.additionalInfo,
        clientError: false,
        clientFetching: false,
      };
    case types.GET_CLIENT_DATA_FAILURE:
      return {
        ...state,
        clientError: payload,
        clientFetching: false,
      };
    case types.RESET_CLIENT_DATA:
      return {
        ...state,
        clientInfo: null,
        clientError: false,
        clientFetching: false,
      };
    case types.GET_DEBT_PAYMENT_BEGIN:
      return {
        ...state,
        debtPayment: null,
        debtPaymentFetching: true,
        debtPaymentError: false,
      };
    case types.GET_DEBT_PAYMENT_SUCCESS:
      return {
        ...state,
        debtPayment: payload,
        debtPaymentFetching: false,
        debtPaymentError: false,
      };
    case types.GET_DEBT_PAYMENT_FAILURE:
      return {
        ...state,
        debtPaymentFetching: false,
        debtPaymentError: true,
      };
    case types.GET_EMAIL_MOVISTAR_PLUS_BEGINS:
      return {
        ...state,
        emailMovistarPlusFetching: true,
        emailMovistarPlusFetched: false,
        emailMovistarPlusError: false,
      };
    case types.GET_EMAIL_MOVISTAR_PLUS_SUCCESS: {
      return {
        ...state,
        emailMovistarPlus: payload,
        emailMovistarPlusError: false,
        emailMovistarPlusFetching: false,
        emailMovistarPlusFetched: true,
      };
    }
    case types.GET_EMAIL_MOVISTAR_PLUS_FAILURE:
      return {
        ...state,
        emailMovistarPlusError: payload,
        emailMovistarPlusFetching: false,
        emailMovistarPlusFetched: true,
      };
    // CONTACT MEANS
    case types.GET_EMAILS_MOVISTAR_PLUS_BEGINS:
      return {
        ...state,
        emailsMovistarPlusFetching: true,
        emailsMovistarPlusFetched: false,
        emailsMovistarPlusError: false,
      };
    case types.GET_EMAILS_MOVISTAR_PLUS_SUCCESS: {
      return {
        ...state,
        emailsMovistarPlus: payload,
        emailsMovistarPlusError: false,
        emailsMovistarPlusFetching: false,
        emailsMovistarPlusFetched: true,
      };
    }
    case types.GET_EMAILS_MOVISTAR_PLUS_FAILURE:
      return {
        ...state,
        emailsMovistarPlusError: payload,
        emailsMovistarPlusFetching: false,
        emailsMovistarPlusFetched: true,
      };
    case types.POST_MODIFY_CONTACT_MEANS_BEGIN:
      return {
        ...state,
        modifyContactMeans: null,
        modifyContactMeansFetching: true,
        modifyContactMeansError: false,
      };
    case types.POST_MODIFY_CONTACT_MEANS_SUCCESS:
      return {
        ...state,
        modifyContactMeans: payload,
        modifyContactMeansFetching: false,
        modifyContactMeansError: false,
      };
    case types.POST_MODIFY_CONTACT_MEANS_FAILURE: {
      return {
        ...state,
        modifyContactMeans: null,
        modifyContactMeansFetching: false,
        modifyContactMeansError: true,
      };
    }
    case types.RESET_MODIFY_CONTACT_MEANS:
      return {
        ...state,
        modifyContactMeans: null,
        modifyContactMeansFetching: false,
        modifyContactMeansError: false,
        clientDataUpdated: false,
      };
    case types.CLIENTE_DATA_UPDATE:
      return {
        ...state,
        clientDataUpdated: true,
      }
    case types.RESET_CLIENTE_DATA_UPDATE:
      return {
        ...state,
        clientDataUpdated: false,
      }
    case types.SET_URLS_CLIENT:
      const urlLibrary = payload;
      return {
        ...state,
        urlLibrary: urlLibrary,
      };
    //DEBT
    case types.GET_DEBT_PAYMENT_BEGIN:
      return {
        ...state,
        debtPayment: null,
        debtPaymentFetching: true,
        debtPaymentError: false,
      };
    case types.GET_DEBT_PAYMENT_SUCCESS:
      return {
        ...state,
        debtPayment: action.payload,
        debtPaymentFetching: true,
        debtPaymentError: false,
      };
    case types.GET_DEBT_PAYMENT_FAILURE:
      return {
        ...state,
        debtPayment: null,
        debtPaymentFetching: false,
        debtPaymentError: true,
      };
    // NEW CONTACT MEANS
    case types.SET_NEW_CONTACT:
      return {
        ...state,
        newContact: payload,
      };
    case types.RESET_NEW_CONTACT:
      return {
        ...state,
        newContact: null,
      }
    // CHANGE PASSWORD
    case types.CHANGE_PASSWORD_BEGINS:
      return {
        ...state,
        changePasswordStatus: null,
        changePasswordFetching: true,
        changePasswordError: null,
      };
    case types.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordStatus: 'OK',
        changePasswordFetching: false,
        changePasswordError: null,
      };
    case types.CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        changePasswordStatus: null,
        changePasswordFetching: false,
        changePasswordError: action.payload,
      };
    case types.CHANGE_PASSWORD_RESET:
      return {
        ...state,
        changePasswordStatus: null,
        changePasswordFetching: false,
        changePasswordError: null,
      };
    default:
      return state;
  }
}

export default reducer;
